import {isFeatureEnabled} from '@github-ui/feature-flags'
import {issueAgentTasksPath} from '@github-ui/paths'
import {useQuery} from '@github-ui/react-query'
import {reactFetchJSON} from '@github-ui/verified-fetch'

import type {APITask} from '../types/api-task'
import type {AgentInfo} from '../types/session'

export type IssueAgentTask = APITask & {
  url?: string
}

export type IssueAssignedAgentInfo = AgentInfo & {
  // TODO: The API which serves `AgentInfo` also returns a number, but the type appears to be incorrect. I didn't
  // want to add that change to the scope of this work though.
  id: number
}

export type IssueAgentTasksResponse = {
  tasks: IssueAgentTask[]
  assigned_agents?: IssueAssignedAgentInfo[]
}

export type UseIssueAgentTasksParams = {
  owner: string
  repo: string
  issueNumber: number
}

/**
 * Fetches agent tasks for a given issue via the REST API.
 */
export function useIssueAgentTasks({owner, repo, issueNumber}: UseIssueAgentTasksParams) {
  const isAgentTasksFetchEnabled =
    isFeatureEnabled('issue_cca_visualization') || isFeatureEnabled('issue_cca_visualization_session_panel')
  const enabled =
    isAgentTasksFetchEnabled && owner.length > 0 && repo.length > 0 && Number.isInteger(issueNumber) && issueNumber > 0

  return useQuery<IssueAgentTasksResponse>({
    enabled,
    queryKey: ['issue-agent-tasks', owner, repo, issueNumber],
    queryFn: async () => {
      const response = await reactFetchJSON(issueAgentTasksPath({owner, repo, issueNumber}))

      if (!response.ok) {
        throw new Error(`Failed to fetch agent tasks: ${response.status}`)
      }

      return (await response.json()) as IssueAgentTasksResponse
    },
    retry: false,
  })
}
